import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useSMLCountryParam } from './useSMLCountryParam';
import { useSMLGenreParam } from './useSMLGenreParam';

interface UseArtistsTopGainingProps {
  page: number;
  limit?: number;
  date?: Date;
}

export const useArtistsTopGaining = ({ page, limit = 10, date }: UseArtistsTopGainingProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const { countryCode } = useSMLCountryParam();
  const { genre } = useSMLGenreParam();
  const offset = (page - 1) * limit;

  const artistsQuery = useTRPCQuery(
    trpcMusicAPI.artists.topGaining.queryOptions({
      offset,
      limit,
      date: date ?? undefined,
      countryCode,
      genre,
    })
  );

  return artistsQuery;
};
